import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaTachometerAlt,
  FaGift,
  FaComments,
  FaClipboardList,
  FaBell,
  FaUsers,
  FaUserShield,
  FaMoneyBill,
  FaKey,
} from "react-icons/fa";
import { jwtDecode } from "jwt-decode"; // ✅ Correct named import
import "../styles/Sidebar.css";
import logo from "../Assets/Images/AmericanLogo.png";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  // Extract role from JWT token in localStorage
  let role = "";
  try {
    const token = localStorage.getItem("authToken");
    if (token) {
      const decoded = jwtDecode(token); // ✅ Use correct function name
      role = decoded?.role || "";
    }
  } catch (err) {
    console.error("Error decoding token:", err);
  }

  // Close sidebar on nav click (mobile)
  const handleNavClick = () => {
    if (onClose) onClose();
  };

  return (
    <div className={`sidebar ${isOpen ? "sidebar--open" : ""}`}>
      <div className="sidebar-logo">
        <img src={logo} alt="Logo" className="logo-image" />
      </div>
      <ul className="sidebar-menu">
        <li>
          <Link
            to="/dashboard"
            onClick={handleNavClick}
            className={`sidebar-link ${
              location.pathname === "/dashboard" ? "active" : ""
            }`}
          >
            <FaTachometerAlt className="sidebar-icon" /> Dashboard
          </Link>
        </li>
        {(role === "admin" || role === "branding") && (
          <li>
            <Link
              to="/promotions"
              onClick={handleNavClick}
              className={`sidebar-link ${
                location.pathname === "/promotions" ? "active" : ""
              }`}
            >
              <FaGift className="sidebar-icon" /> Promotions
            </Link>
          </li>
        )}
        {(role === "admin" || role === "Csd") && (
          <li>
            <Link
              to="/assistances"
              onClick={handleNavClick}
              className={`sidebar-link ${
                location.pathname === "/assistances" ? "active" : ""
              }`}
            >
              <FaComments className="sidebar-icon" /> Assistances
            </Link>
          </li>
        )}
        {(role === "admin" || role === "Csd") && (
          <li>
            <Link
              to="/otp-lookup"
              onClick={handleNavClick}
              className={`sidebar-link ${
                location.pathname === "/otp-lookup" ? "active" : ""
              }`}
            >
              <FaKey className="sidebar-icon" /> Customer Lookup
            </Link>
          </li>
        )}
        {(role === "admin" || role === "Csd") && (
          <li>
            <Link
              to="/requests"
              onClick={handleNavClick}
              className={`sidebar-link ${
                location.pathname === "/requests" ? "active" : ""
              }`}
            >
              <FaClipboardList className="sidebar-icon" /> Requests
            </Link>
          </li>
        )}

        {(role === "admin" || role === "manager") && (
          <li>
            <Link
              to="/notifications"
              onClick={handleNavClick}
              className={`sidebar-link ${
                location.pathname === "/notifications" ? "active" : ""
              }`}
            >
              <FaBell className="sidebar-icon" /> Notifications
            </Link>
          </li>
        )}
        {(role === "admin" || role === "manager") && (
          <li>
            <Link
              to="/customers"
              onClick={handleNavClick}
              className={`sidebar-link ${
                location.pathname === "/customers" ? "active" : ""
              }`}
            >
              <FaUsers className="sidebar-icon" /> Customers
            </Link>
          </li>
        )}
        {role === "admin" && (
          <li>
            <Link
              to="/appversion"
              onClick={handleNavClick}
              className={`sidebar-link ${
                location.pathname === "/appversion" ? "active" : ""
              }`}
            >
              <FaClipboardList className="sidebar-icon" /> App Version
            </Link>
          </li>
        )}
        {role === "admin" && (
          <li>
            <Link
              to="/payment"
              onClick={handleNavClick}
              className={`sidebar-link ${
                location.pathname === "/payment" ? "active" : ""
              }`}
            >
              <FaMoneyBill className="sidebar-icon" /> Payment Details
            </Link>
          </li>
        )}
        {role === "admin" && (
          <li>
            <Link
              to="/register"
              onClick={handleNavClick}
              className={`sidebar-link ${
                location.pathname === "/register" ? "active" : ""
              }`}
            >
              <FaUserShield className="sidebar-icon" /> Users
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
